enum Routes {
  HOME = '/home',
  CHOOSE_CLIENT = '/clients/choose',
  CREATE_CLIENT = '/clients/create',
  CHOOSE_QUESTIONNAIRE = '/questionnaire',
  PROCESS_QUESTIONNAIRE = '/questionnaire',
}

export const getChooseQuestionnaire = (clientId: number, success: boolean = false) => `${Routes.CHOOSE_QUESTIONNAIRE}/${success ? 'success/' : ''}${clientId}`;
export const getQuestionnaire = (clientId: number|string, questionnaire: string, page: number = 0) => `${Routes.PROCESS_QUESTIONNAIRE}/${clientId}/${encodeURIComponent(questionnaire)}/${page}`;

export const isChooseQuestionnaireSuccess = () => {
  return window.location.pathname.startsWith(`${Routes.CHOOSE_QUESTIONNAIRE}/success/`);
}

export default Routes;
